import { ProductModel } from '@/types/model/Product'
import { VariantCard } from './VariantCard'

interface VariantsListProps {
  attributes: ProductModel.IAttribute[]
  fields: any[]
  remove: (index: number) => void
}

export const VariantsList = ({ attributes, fields, remove }: VariantsListProps) => {
  const getAttributeValueName = (attributeValueId: string) => {
    for (const attr of attributes) {
      const value = attr.values.find((val) => val._id === attributeValueId)
      if (value) return value.name
    }
    return 'Unknown Value'
  }

  return (
    <div className="space-y-4">
      {fields.map((field, index) => (
        <VariantCard
          key={field.id}
          index={index}
          onRemove={(idx) => remove(idx)}
          attributeValueNames={field.attribute_value_ids?.map(getAttributeValueName).join(' / ') || ''}
          attributes={attributes}
        />
      ))}
      {fields.length === 0 && (
        <div className="rounded-lg border border-dashed border-input px-4 py-10 text-center text-sm text-muted-foreground">
          No variants added yet.
        </div>
      )}
    </div>
  )
}
